import React from "react";
import PropType from "prop-types";
import "./FeaturePanel.css";
import Button from "../../../../Button";
import FadeInSection from "../../FadeInSection";

export default function FeaturePanel(props) {
  return (
    <FadeInSection first={props.rank === 0}>
      <div className="feature-panel">
        <img
          className={
            "feature-panel-img " +
            (props.imageLeft ? "feature-panel-first" : "feature-panel-second")
          }
          src={props.image}
          alt={props.alt}
        />

        <div
          className={
            "feature-panel-text " +
            (props.imageLeft ? "feature-panel-second" : "feature-panel-first")
          }
        >
          <h3 className="feature-panel-byline">{props.byline}</h3>
          <h2 className="feature-panel-title">{props.title}</h2>
          <p className="feature-panel-content">{props.content}</p>

          <Button href="/memberships">Join The Family</Button>
        </div>

        <br />
        <br />
      </div>
    </FadeInSection>
  );
}

FeaturePanel.propTypes = {
  title: PropType.string.isRequired,
  image: PropType.string.isRequired,
  content: PropType.string.isRequired,
  alt: PropType.string.isRequired,
  byline: PropType.string.isRequired,
  imageLeft: PropType.bool.isRequired,
  rank: PropType.number.isRequired,
};
